import type { StorePageSnapshot } from "../store-page.queries";
import type { StorePageEditConflict, StorePageEditResult } from "./types";

export function reconcileConflict({
  previous,
  conflict,
}: {
  readonly previous: StorePageSnapshot | undefined;
  readonly conflict: StorePageEditConflict;
}): StorePageSnapshot | undefined {
  if (!previous) return previous;

  return {
    ...previous,
    draft: {
      current_revision_id: conflict.current_revision_id,
      content: conflict.current_content,
    },
  };
}

export function reconcileRevision({
  previous,
  result,
}: {
  readonly previous: StorePageSnapshot | undefined;
  readonly result: StorePageEditResult;
}): StorePageSnapshot | undefined {
  if (!previous) return previous;

  return {
    draft: {
      current_revision_id: result.page.current_revision_id,
      status: result.revision.status,
      content: result.content,
      first_published_at: previous.draft?.first_published_at ?? null,
    },
    revisions: [
      result.revision,
      ...previous.revisions.filter(
        (revision) => revision.id !== result.revision.id,
      ),
    ],
  };
}
